import React from 'react'

const MarkFinalResultModal = ({
  isShow,
  onHide,
  type,
  recentMarkFinalServiceTxns,
}) => {
  if (!isShow) return null

  return (
    <div>
      {/* Backdrop */}
      <div className="fixed inset-0 bg-black bg-opacity-50 z-50" />

      {/* Dialog */}
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
        <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-[80vh] overflow-hidden">
          {/* Header */}
          <div className="flex items-center justify-between p-4 border-b border-gray-200 bg-gray-50">
            <h3 className="text-lg font-semibold text-gray-900">
              Scan Code: {type ? type.toUpperCase() : ''}
            </h3>
            <button
              onClick={onHide}
              className="text-gray-400 hover:text-gray-600 transition-colors"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>

          {/* Body */}
          <div className="p-6 overflow-y-auto max-h-[calc(80vh-80px)]">
            <div className="text-center mb-6">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-primary-100 rounded-full mb-3">
                <svg
                  className="w-8 h-8 text-primary-600"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 4v1m6 11h2m-6 0h-2v4m0-11v3m0 0h.01M12 12h4.01M16 20h4M4 12h4m12 0h.01M5 8h2a1 1 0 001-1V5a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1zm12 0h2a1 1 0 001-1V5a1 1 0 00-1-1h-2a1 1 0 00-1 1v2a1 1 0 001 1zM5 20h2a1 1 0 001-1v-2a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1z"
                  />
                </svg>
              </div>
              <p className="text-lg font-semibold text-gray-900">
                Waiting for code scanning
              </p>
              <p className="text-sm text-gray-500 mt-1">
                Please scan a barcode or QR code
              </p>
            </div>

            {renderMarkFinalServiceTxns(recentMarkFinalServiceTxns)}
          </div>
        </div>
      </div>
    </div>
  )
}

const renderMarkFinalServiceTxns = (recentMarkFinalServiceTxns) => {
  if (!recentMarkFinalServiceTxns || recentMarkFinalServiceTxns.length === 0)
    return null

  return (
    <div className="space-y-3">
      <h4 className="text-sm font-semibold text-gray-700 uppercase tracking-wide mb-3">
        Recent Scans
      </h4>
      <div className="space-y-2">
        {recentMarkFinalServiceTxns.map((serviceTxn) => (
          <div
            key={serviceTxn._id}
            className="bg-gray-50 rounded-lg p-4 border border-gray-200 hover:border-primary-300 transition-colors"
          >
            <div className="font-semibold text-gray-900 mb-1">
              {serviceTxn.service.displayName}
            </div>
            <div className="text-sm text-gray-600">
              CN: {serviceTxn.reservation.confirmationNumber} - SEQ:{' '}
              {serviceTxn.seq} - {serviceTxn.customerName}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default MarkFinalResultModal
